module.exports = {
    CM_FILTER_BY_ASSOCIATED_ACCOUNT: 'CM_FILTER_BY_ASSOCIATED_ACCOUNT',
    CM_LEGAL_DOCUMENT_MARKETING_REPORTS_FETCH_SUCCESS:
        'CM_LEGAL_DOCUMENT_MARKETING_REPORTS_FETCH_SUCCESS',
    CM_LEGAL_DOCUMENT_MORNING_STAR_EXT_FETCH_REQUEST:
        'CM_LEGAL_DOCUMENT_MORNING_STAR_EXT_REQUEST',
    CM_LEGAL_DOCUMENT_MORNING_STAR_EXT_FETCH_FAILURE:
        'CM_LEGAL_DOCUMENT_MORNING_STAR_EXT_FAILURE',
    CM_LEGAL_DOCUMENT_MORNING_STAR_EXT_FETCH_SUCCESS:
        'CM_LEGAL_DOCUMENT_MORNING_STAR_EXT_SUCCESS',
    CM_SYNC: 'CM_SYNC',
    CM_SET_VISIBLE_STEP: 'CM_SET_VISIBLE_STEP',
    CM_GET_PORTFOLIOS_LIST_REQUEST: 'CM_GET_PORTFOLIOS_LIST_REQUEST',
    CM_GET_PORTFOLIOS_LIST_ERROR: 'CM_GET_PORTFOLIOS_LIST_ERROR',
    CM_GET_PORTFOLIOS_LIST_SUCCESS: 'CM_GET_PORTFOLIOS_LIST_SUCCESS',
    CM_FILTER_CHANGE_WALLET: 'CM_FILTER_CHANGE_WALLET',
    CM_WILL_CANCEL: 'CM_WILL_CANCEL',
    CM_WILL_LEAVE: 'CM_WILL_LEAVE',
    CM_VALIDATE_STEP: 'CM_VALIDATE_STEP',
    CM_FROM_FUNDS_VALIDATE_STEP: 'CM_FROM_FUNDS_VALIDATE_STEP',
    CM_TRANSFER_MONEY_VALIDATE_STEP: 'CM_TRANSFER_MONEY_VALIDATE_STEP',
    CM_RESET_STEP: 'CM_RESET_STEP',
    CM_DISABLE_NEXT_BUTTON: 'CM_DISABLE_NEXT_BUTTON',
    CM_ENABLE_NEXT_BUTTON: 'CM_ENABLE_NEXT_BUTTON',
    CM_LEAVE_TRANSFER_MONEY_TO_OTHER_PAGE_CONFIRMED:
        'CM_LEAVE_TRANSFER_MONEY_TO_OTHER_PAGE_CONFIRMED',
    CM_ACTIVATE_TRANSFER_MONEY_PRE_LEAVE_MODAL:
        'CM_ACTIVATE_TRANSFER_MONEY_PRE_LEAVE_MODAL',
    CM_DEACTIVATE_TRANSFER_MONEY_PRE_LEAVE_MODAL:
        'CM_DEACTIVATE_TRANSFER_MONEY_PRE_LEAVE_MODAL',
    CM_SET_ACCOUNT_CHANGED: 'CM_SET_ACCOUNT_CHANGED',
    CM_GET_INTERVENERS_SUCCESS: 'CM_GET_INTERVENERS_SUCCESS',
    CM_RESTORE_DEFAULT_INTERVENERS: 'CM_RESTORE_DEFAULT_INTERVENERS',
    CM_SET_ACCOUNT_INTERVENER_NAME: 'CM_SET_ACCOUNT_INTERVENER_NAME',
    CM_SET_ACCOUNT_INTERVENER_TYPE: 'CM_SET_ACCOUNT_INTERVENER_TYPE',
    CM_SET_ACCOUNT: 'CM_SET_ACCOUNT',
    CM_SET_AMOUNT: 'CM_SET_AMOUNT',
    CM_SET_INITIAL_AMOUNT: 'CM_SET_INITIAL_AMOUNT',
    CM_GET_INTERVENERS_REQUEST: 'CM_GET_INTERVENERS_REQUEST',
    CM_GET_INTERVENERS_ERROR: 'CM_GET_INTERVENERS_ERROR',
    CM_GET_PORTFOLIO_RISK_CATEGORIZATION_SUCCESS:
        'CM_GET_PORTFOLIO_RISK_CATEGORIZATION_SUCCESS',
    CM_LEGAL_DISCLAIMER_CHANGED: 'CM_LEGAL_DISCLAIMER_CHANGED',
    CM_VALIDATE_REQUEST: 'CM_VALIDATE_REQUEST',
    CM_VALIDATE_SUCCESS: 'CM_VALIDATE_SUCCESS',
    CM_VALIDATE_FAILURE: 'CM_VALIDATE_FAILURE',
    CM_SAVE_ORIGIN_FUND_INFO: 'CM_SAVE_ORIGIN_FUND_INFO',
    CM_RUN_CALCULATOR_SERVICE_REQUEST: 'CM_RUN_CALCULATOR_SERVICE_REQUEST',
    CM_RUN_CALCULATOR_SERVICE_SUCCESS: 'CM_RUN_CALCULATOR_SERVICE_SUCCESS',
    CM_RUN_CALCULATOR_SERVICE_FAILURE: 'CM_RUN_CALCULATOR_SERVICE_FAILURE',
    CM_RUN_ORCHESTRATOR_SERVICE_REQUEST: 'CM_RUN_ORCHESTRATOR_SERVICE_REQUEST',
    CM_RUN_ORCHESTRATOR_SERVICE_SUCCESS: 'CM_RUN_ORCHESTRATOR_SERVICE_SUCCESS',
    CM_RUN_ORCHESTRATOR_SERVICE_FAILURE: 'CM_RUN_ORCHESTRATOR_SERVICE_FAILURE',
    CM_WALLET_BUY_FINISH: 'CM_WALLET_BUY_FINISH',
    CM_RESET_ORIGIN_FUND: 'CM_RESET_ORIGIN_FUND',
    FETCH_CM_PORTFOLIO_INFO_REQUEST: 'FETCH_CM_PORTFOLIO_INFO_REQUEST',
    FETCH_CM_PORTFOLIO_INFO_SUCCESS: 'FETCH_CM_PORTFOLIO_INFO_SUCCESS',
    FETCH_CM_PORTFOLIO_INFO_FAILURE: 'FETCH_CM_PORTFOLIO_INFO_FAILURE',
    FETCH_CM_CONTRACTS_ORIGIN_TRANSFER_REQUEST:
        'FETCH_CM_CONTRACTS_ORIGIN_TRANSFER_REQUEST',
    FETCH_CM_CONTRACTS_ORIGIN_TRANSFER_SUCCESS:
        'FETCH_CM_CONTRACTS_ORIGIN_TRANSFER_SUCCESS',
    FETCH_CM_FUNDS_MIN_AMOUNTS_REQUEST: 'FETCH_CM_FUNDS_MIN_AMOUNTS_REQUEST',
    FETCH_CM_FUNDS_MIN_AMOUNTS_SUCCESS: 'FETCH_CM_FUNDS_MIN_AMOUNTS_SUCCESS',
    FETCH_CM_FUNDS_MIN_AMOUNTS_FAILURE: 'FETCH_CM_FUNDS_MIN_AMOUNTS_FAILURE',
    FETCH_CM_PORTFOLIO_RISK_CATEGORIZATION_INFO_REQUEST:
        'FETCH_CM_PORTFOLIO_RISK_CATEGORIZATION_INFO_REQUEST',
    POST_CM_ORDER_CONFIRMATION_IN_PROGRESS:
        'POST_CM_ORDER_CONFIRMATION_IN_PROGRESS',
    POST_CM_ORDER_CONFIRMATION_SUCCESS: 'POST_CM_ORDER_CONFIRMATION_SUCCESS',
    POST_CM_FROM_FUNDS_ORDER_CONFIRMATION_IN_PROGRESS:
        'POST_CM_FROM_FUNDS_ORDER_CONFIRMATION_IN_PROGRESS',
    POST_CM_FROM_FUNDS_ORDER_CONFIRMATION_SUCCESS:
        'POST_CM_FROM_FUNDS_ORDER_CONFIRMATION_SUCCESS',
    CM_LEGAL_DOCUMENT_COST_FETCH: 'CM_LEGAL_DOCUMENT_COST_FETCH',
    CM_SUBMIT_SUCCESSFUL: 'CM_SUBMIT_SUCCESSFUL',
    CM_LEGAL_DOCUMENT_COST_FETCH_ERROR: 'CM_LEGAL_DOCUMENT_COST_FETCH_ERROR',
    CM_LEGAL_DOCUMENT_COST_FETCH_SUCCESS:
        'CM_LEGAL_DOCUMENT_COST_FETCH_SUCCESS',
    CM_BUY_TYPE_CHANGED: 'CM_BUY_TYPE_CHANGED',
    BROKER_WIZARD_INTERNAL_TRANSFER_SET_ORIGIN_FUND_ID:
        'BROKER_WIZARD_INTERNAL_TRANSFER_SET_ORIGIN_FUND_ID',
    CM_SET_FUND_ID_MATCHED_IN_PORTFOLIO: 'CM_SET_FUND_ID_MATCHED_IN_PORTFOLIO',
    CM_LEGAL_UNIFIED_DOCUMENT_FETCH_SUCCESS:
        'CM_LEGAL_UNIFIED_DOCUMENT_FETCH_SUCCESS',
    CM_VALIDATE_ALL_DOCUMENTS_READS_DIRTY:
        'CM_VALIDATE_ALL_DOCUMENTS_READS_DIRTY',
    CM_REMOVE_INTERVENER: 'CM_REMOVE_INTERVENER',
    CM_ADD_INTERVENER: 'CM_ADD_INTERVENER',
    CM_SET_INTERVENER_TYPE: 'CM_SET_INTERVENER_TYPE',
    CM_SHOW_MESSAGE_ERROR_CHECK: 'CM_SHOW_MESSAGE_ERROR_CHECK',
    CM_CHANGE_CHECK: 'CM_CHANGE_CHECK',
};
